
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import * as echarts from "echarts";
import { PsycResult } from "@/lib/model/exam/result";

const option = {
  color: ["#5C2DFFFF"],
  tooltip: {
    show: false,
    trigger: "axis",
    axisPointer: {
      type: "cross",
      label: {
        backgroundColor: "#6a7985"
      }
    }
  },

  grid: {
    left: "5.5%",
    right: "5.5%",
    bottom: "4px",
    top: "0px",
    containLabel: true,
    borderColor: "#f5f5f5"
  },
  xAxis: [
    {
      silent: true,
      position: "top",
      type: "category",
      boundaryGap: true,

      data: ["D", "I", "S", "C"],
      axisTick: {
        show: false
      },
      axisLine: {
        show: false,

        lineStyle: {
          color: "#EAEDF7"
        }
      },
      axisLabel: {
        show: false,

        color: "#111111"
      },
      splitLine: {
        show: false
      },
      splitArea: {
        show: false //斑马
      }
    }
  ],
  yAxis: [
    {
      silent: true,
      type: "value",
      axisTick: {
        show: false,
        inside: true, //刻度
        lineStyle: {
          color: "#EAEDF7"
        }
      },
      splitLine: {
        show: false
      },
      max: 48,
      axisLabel: {
        show: false,
        color: "#111111"
      }
    }
  ],
  series: [
    {
      silent: true,
      name: "",
      type: "line",
      stack: "Total",
      smooth: false,
      lineStyle: {
        width: 3.5,
        cap: "round"
        // shadowBlur: 6,
        // shadowOffsetY: 14,
        // // shadowOffsetX: 8,
        // opacity: 0.8
      },
      itemStyle: {
        //拐点边框
        borderType: "solid",
        borderWidth: 2,
        borderColor: "#ffffff"
      },
      showSymbol: true, //拐点
      symbol: "circle",
      symbolSize: 10,
      areaStyle: {
        opacity: 0,
        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          {
            offset: 0,
            color: "rgba(82, 95, 255, 0.13)"
          },
          {
            offset: 0.8,
            color: "rgba(82, 95, 255, 0)"
          }
        ])
      },
      emphasis: {
        focus: "series"
      },
      data: [0],
      animationEasing: "bounceOut",
      animationDuration: 1500
    }
  ]
};

@Component({
  components: {}
})
export default class EchartsDisc extends Vue {
  @Prop({}) data!: PsycResult;
  @Prop({ default: false, type: Boolean }) isH5!: boolean;

  setRadius(row: number, td: number) {
    if (row === 1 && td === 1) {
      return "border-radius:4px 0 0 0";
    }
    if (row === 1 && td === 9) {
      return "border-radius:0 4px  0 0";
    }
    if (row === 6 && td === 1) {
      return "border-radius: 0 0 0 4px";
    }
    if (row === 6 && td === 9) {
      return "border-radius:0 0 4px 0";
    }
  }

  created() {
    //
  }
  mounted() {
    console.log(this.data);
    this.initEchart();
  }

  get scoreList() {
    return this.data.newResultList.map(item => {
      return item.score;
    });
  }

  get resTextList() {
    return this.data.newResultList.filter(item => {
      return item.isMatch;
    });
  }

  initEchart() {
    const echart = echarts.init(this.$refs.echart as any);
    if (echart) {
      option.series[0].data = this.scoreList;
      echart.setOption(option);
      window.addEventListener("resize", () => {
        echart.resize();
      });
    }
  }
}
